import { FetcherResponse } from '../../../../../../components/Hooks/useList.types';
import { Message } from '../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import {
  ChatMessagesActions,
  RemoveWsMessagePayload,
  SetMessagesFilterByPayload,
} from './chatMessages.state.types';

export const fetchingMore = (): ChatMessagesActions => ({ type: 'FETCHING_MORE' });

export const fetchMessagesResult = (payload: FetcherResponse<Message>): ChatMessagesActions => ({
  type: 'FETCH_MESSAGES_RESULT',
  payload,
});

export const incrementNewWsMessage = (payload: { message: Message }): ChatMessagesActions => ({
  type: 'INCREMENT_NEW_WS_MESSAGE',
  payload,
});

export const removeWsMessage = (payload: RemoveWsMessagePayload): ChatMessagesActions => ({
  type: 'REMOVE_WS_MESSAGE',
  payload,
});

export const goToEditChat = (): ChatMessagesActions => ({ type: 'GO_TO_EDIT_CHAT' });

export const goToChat = (): ChatMessagesActions => ({ type: 'GO_TO_CHAT' });

export const setMessagesOfType = (payload: SetMessagesFilterByPayload): ChatMessagesActions => ({
  type: 'SET_MESSAGES_FILTER_BY',
  payload,
});
